/* Response Time CSS */

export default theme => ({
    root: {},
    chart: {
      width: '500px',
      margin: '0 auto',
      //height: '300px',
      textAlign: 'center',
    },
    header: {
      height: '40px',
      color: theme.palette.text.secondary
    },
    portletFooter: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    backGrey:{
      backgroundColor:"#0b1738"
    },
    backGrey2:{
      backgroundColor:"#0f1d45",
      marginBottom: "0px !important",
      marginTop: "0px !important",
      borderRadius: 0,
    },
    backWhite:{
      backgroundColor:"white"
    },
    textWhite:{
      color:"white"
    },
    details: {
      
      padding: '50px',
      flex: '1 100%',
      marginTop: '50px',
      marginBottom: '50px',
      marginRight: '50px',
      marginLeft: '50px'
    },
  
  });
  
  